export default "__VITE_ASSET__ux3hgTat__"